import { FC } from 'react';

interface Props {
  color?: string;
  className?: string;
}

const StarSvg: FC<Props> = ({ color, className }) => {
  return (
    <svg
      className={className}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M2.61569 4.34488C3.71173 3.14179 5.27958 2.47418 7.14001 2.47418C8.90254 2.47418 10.7973 3.35011 11.9989 5.06731C13.1958 3.35089 15.0821 2.47418 16.86 2.47418C18.7144 2.47418 20.2819 3.1384 21.3794 4.33961C22.4686 5.53166 23.025 7.17473 23.025 9.0194C23.025 12.1837 21.4001 14.7431 19.3117 16.7518C17.227 18.7569 14.6028 20.2909 12.4136 21.4235C12.153 21.5584 11.843 21.5577 11.583 21.4217C9.39221 20.2762 6.76741 18.7537 4.68428 16.7584C2.59517 14.7574 0.975006 12.2054 0.975006 9.0194C0.975006 7.18109 1.52837 5.53839 2.61569 4.34488ZM3.9463 5.5571C3.21879 6.35567 2.77501 7.53558 2.77501 9.0194C2.77501 11.5382 4.0431 13.6517 5.92937 15.4585C7.70121 17.1556 9.95126 18.5151 12.0019 19.6076C14.0413 18.5293 16.2909 17.1597 18.0639 15.4545C19.9545 13.6361 21.225 11.5143 21.225 9.0194C21.225 7.53045 20.7789 6.35091 20.0506 5.55376C19.3306 4.76576 18.2656 4.27418 16.86 4.27418C15.3035 4.27418 13.5381 5.27348 12.855 7.35202C12.7336 7.72136 12.3888 7.97101 12 7.97101C11.6112 7.97101 11.2664 7.72136 11.145 7.35202C10.4624 5.27518 8.68011 4.27418 7.14001 4.27418C5.72973 4.27418 4.66508 4.76812 3.9463 5.5571Z'
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
};

export default StarSvg;
